import axios from "../axios-control";

export const todos = () => axios
    .get('/usuarios')
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const cargaUno = id => axios
    .get(`/usuarios/${id}`)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const actualiza = tipo => axios
    .put(`/usuarios/${tipo.id}`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const crea = tipo => axios
    .post(`/usuarios`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const eliminar = tipo => axios
    .delete(`/usuarios/${tipo.id}`)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });